import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/pro-solid-svg-icons"
import PropTypes from 'prop-types'
import BaseButton from './BaseButton'


export default function ButtonAdd({
  className,
  disabled,
  loading,
  onClick,
  size,
  solid,
  title,
}) {

  return (
    <BaseButton
      className={solid ? "add-button-solid" : "add-button" + (className ? " " + className : "")}
      icon={
        <FontAwesomeIcon icon={faPlus} />
      }
      type="text"
      size={size}
      title={title || "Add"}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
    />
  )
}

ButtonAdd.propTypes = {
  title: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf([
    'large',
    'middle',
    'small'
  ]),
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  solid: PropTypes.bool,
}
